import React from 'react';
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  Platform,
  Dimensions,
} from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { useTheme } from '../../../theme';

interface ActionPlanWelcomeProps {
  onCreateNewActionPlan: () => void;
}

const ActionPlanWelcome: React.FC<ActionPlanWelcomeProps> = ({
  onCreateNewActionPlan,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';
  const screenWidth = Dimensions.get('window').width;
  const isWeb = Platform.OS === 'web';
  const isTablet = screenWidth >= 768 && screenWidth < 1024;
  const isMobile = screenWidth < 768;

  return (
    <View style={styles.container}>
      {/* Header Section */}
      <View style={[styles.headerSection, isMobile && styles.headerSectionMobile]}>
        <View style={[styles.titleContainer, isMobile && styles.titleContainerMobile]}>
          <Text style={[styles.title, isDark && { color: colors.text.primary }]}>
            {isWeb ? 'Action Plans' : 'Action Plan'}
          </Text>
        </View>

        {/* New Action Plan Button */}
        <TouchableOpacity
          onPress={onCreateNewActionPlan}
          style={[
            styles.button,
            isDark && { backgroundColor: colors.brand.primary },
            isMobile && styles.buttonMobile,
            isTablet && styles.buttonTablet,
          ]}
          activeOpacity={0.8}
        >
          <MaterialIcons name="add" size={20} color="#FFFFFF" />
          <Text style={styles.buttonText}>New Action Plan</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: 'transparent',
    paddingVertical: 16,
  },
  headerSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  headerSectionMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 12,
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  titleContainerMobile: {
    paddingTop: 16,
  },
  icon: {
    marginRight: 4,
  },
  title: {
    fontSize: 28,
    fontWeight: '700',
    color: '#2D2D2D',
    lineHeight: 39,
  },
  button: {
    backgroundColor: '#034895',
    paddingVertical: 8,
    paddingHorizontal: 24,
    borderRadius: 24,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    minHeight: 40,
  },
  buttonMobile: {
    width: '100%',
    paddingHorizontal: 16,
    minHeight: 36,
  },
  buttonTablet: {
    paddingHorizontal: 20,
    minHeight: 38,
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 22,
  },
});

export default ActionPlanWelcome;

